<template>
  <div>
    <dialog-warp v-model="showPayment">
      <div class="payment-dialog">
        <div class="payment-dialog-line" @click="onClose()"></div>
        <h2 class="payment-dialog-tle">{{ i18n.choosepaymethod }}</h2>
        <div class="payment-list">
          <div v-for="item in payModeList" :key="item.pId">
            <payment-item
              :item="item"
              :payMode="payMode"
              @onPayMode="onPayMode"
            ></payment-item>
          </div>
        </div>
        <div class="payment-btns">
          <div class="btn" @click="onPay">
            {{ i18n.confrimpay }}
          </div>
        </div>
      </div>
    </dialog-warp>
    <stripe-pay
      ref="STRIPE_CARD"
      v-if="supportStripeMode"
      :payCode="payCode"
      :payType="payType"
      :payPrice="payPrice"
      :outTradNo="outTradNo"
      :publicKey="payMode.publicKey"
    ></stripe-pay>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { PAYMODE } from "./apis/payment"

import paymentMixin from "./mixins/index"
import paypalMixin from "./component/paypal_pay/index"
import weChatPayMixin from "./component/wechat_pay/index"
import StripePay from "./component/stripe_pay/index.vue"
import DialogWarp from "./component/common/dialog_warp"
import PaymentItem from "./component/common/payment_item"

export default {
  props: {
    cardList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  mixins: [paymentMixin, paypalMixin, weChatPayMixin],
  components: {
    PaymentItem,
    DialogWarp,
    StripePay
  },
  data() {
    return {
      showPayment: false,
      payType: "", // 支付类型
      payCode: "", // 支付码
      payPrice: "", // 支付价格
      outTradNo: "", // 订单号
      payMode: {},
      payModeList: []
    }
  },
  computed: {
    ...mapState(["system", "browser", "userType"]),
    i18n() {
      return this.$t("paymethod")
    },
    i18nPay() {
      return this.$t("confirm")
    },
    payModeType() {
      const val = this.payMode
      let p_type = val.pPaymentType && val.pPaymentType.toLocaleUpperCase()
      return p_type || ""
    },
    supportStripeMode() {
      // GOOGLE_PAY APPLE_PAY todo
      const supportPay =
        this.payModeType.includes("GOOGLE") ||
        this.payModeType.includes("APPLE")
      return this.payModeType.includes("STRIPE") || supportPay
    }
  },
  watch: {
    // payMode(val, oldVal) {}
  },
  methods: {
    // 初始化支付
    initBajiePayment(param = {}) {
      console.log(" initBajiePayment ~ param:", param)
      Object.keys(param).forEach((key) => {
        this[key] = param[key]
      })
      this.getPayMode()
    },
    // 支付方式切换
    onPayMode(item) {
      this.payMode = item
    },
    // 支付
    onPay() {
      const payMode = { ...this.payMode }
      const paymentType = payMode.pPaymentType
      if (paymentType === "STRIPE_CARD" || this.supportStripeMode) {
        if (!this.$refs["STRIPE_CARD"]) return setTimeout(this.onPay, 420)
        this.$refs["STRIPE_CARD"].onCreditcard(payMode, this.paymentCallBack)
      } else if (
        paymentType === "STRIPE_WECHAT" ||
        paymentType === "WeChat_MP"
      ) {
        if (this.userType === "tourist_login") {
          this.$toast(this.$t("mine.login_tips"))
          return this.$router.push("/login")
        }
        payMode.payCode = this.payCode
        payMode.payPrice = this.payPrice
        this.onWechatPay(payMode, (res) => {
          this.paymentCallBack(res)
        })
      } else if (paymentType === "PAYPAL") {
        payMode.payCode = this.payCode
        if (this.payType == "FK") {
          payMode.outTradNo = this.outTradNo
        }
        this.paypalPay(payMode, this.payType)
      } else {
        console.warn("支付方式暂不支持", payMode)
      }
    },
    /**
     * 获取支付方式
     */
    async getPayMode() {
      const param = { id: this.payCode }
      if (this.payType === "CZ") {
        const agentId = this.wallet ? this.wallet.pDailiId : this.agentOpenId
        param.agentId = agentId
      } else if (this.payType === "overbuy") {
        param.pOrderId = this.outTradNo
      }
      this.$loading(true)
      const result = await this.$Request("get", PAYMODE, param)
      if (result.code === 0 && result.data && result.data.length) {
        this.showPayment = true
        const payModeList = await this.supportPayMode(result.data)
        this.payMode = payModeList[0]
        // 默认支付方式只有一个，直接执行支付操作
        if (payModeList.length === 1) {
          this.onClose()
          return this.onPay()
        }
        this.payModeList = payModeList
      } else {
        console.warn("PAYMODE", result.msg)
      }
      this.$loading(false)
    },
    // 关闭支付弹窗
    onClose() {
      this.showPayment = false
    },
    // 支付回调
    paymentCallBack(res, callback) {
      console.info("paymentCallBack ~ res:", res)
      if (res && res.data) {
        // 订单同步时间差，延迟2秒回调
        setTimeout(() => {
          if (res.confirm_pay_type && res.confirm_pay_type === "order") {
            return this.$router.go(-3)
          }
          this.$emit("onPaymentHandle", { ...res.data })
          callback && callback(res.data)
        }, 2200)
      } else if (res.errMsg) {
        this.$toast(res.errMsg)
      }
    },
    /**
     * 支付确认
     * @param param paymentType 支付类型
     * @param callback
     */
    payConfirm(param, callback) {
      let { payType, tradeNo } = this.$route.query
      const callBack = (res) => this.paymentCallBack(res, callback)
      let out_trade_no = ""
      console.log("payConfirm ~ param:", param)
      if (param.paymentType === "STRIPE_CARD") {
        this.payMode.pPaymentType = param.paymentType
        let sTime = setTimeout(() => {
          let payBox = this.$refs[param.paymentType]
          if (payBox) {
            if (payType === "FK" && tradeNo) {
              out_trade_no = tradeNo
              param.paymentIntent = ""
            }
            payBox.stripePayConfirm(param.paymentIntent, out_trade_no, callBack)
            clearTimeout(sTime)
          } else {
            this.payConfirm(param, callBack)
          }
        }, 300)
      } else if (param.paymentType === "PAYPAL") {
        this.palPayConfirm(param, callBack)
      }
    }
  },
  created() {
    let { token, PayerID } = this.$route.query
    const paymentIntent = new URLSearchParams(window.location.search).get(
      "payment_intent"
    )
    if (paymentIntent) {
      this.$loading(true)
      this.payConfirm({ paymentType: "STRIPE_CARD", paymentIntent })
    } else if (PayerID && token) {
      this.$loading(true)
      this.payConfirm({ paymentType: "PAYPAL", token, PayerID })
    }
  },
  mounted() {}
}
</script>

<style lang="less" scoped>
.payment-list {
  max-height: 42vh;
  overflow-x: auto;
}
.payment-dialog {
  width: 100%;
  max-height: 85%;
  overflow-y: scroll;
  box-sizing: border-box;
  background: #fff;
  border-top-left-radius: 60px;
  border-top-right-radius: 60px;
  padding: 20px 40px 75px;
  &-line {
    background-color: #ebebeb;
    width: 30%;
    height: 8px;
    border-radius: 100px;
    margin: 20px auto;
  }
  &-tle {
    font-size: 32px;
    font-family: Work Sans-Bold, Work Sans;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
  }
}
.payment-btns {
  margin-top: 64px;
}
</style>
